import React, { Component } from 'react';
import UploadDoc from '../components/UploadDoc';
import ActionBar from '../../ActionBar';
import { addEquipment, fieldChange, initEAPForm } from 'redux/ducks/Post/EAP/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { get, isEmpty } from 'lodash';
import { saveLocalForm } from 'redux/ducks/Post/actions';
import { trackMixpanelPageView } from 'helpers/post';

class EmergencyActionPlan extends Component {
  componentDidMount() {
    if (!this.props.editMode) trackMixpanelPageView('create-event/eap/eap-type', this.props.user);

    // const { shiftLocation, details } = this.props;
    const callback = () => this.props.saveLocalForm();

    // if (details.id) {
    //   this.props.initEAPForm(details.id, shiftLocation.id);
    // }
    callback();
  }

  // Bug fix for the new users
  // componentDidUpdate(prevProps) {
  //   const { shiftLocation, details } = this.props;
  //   if (!prevProps.details.id && details.id) {
  //     this.props.initEAPForm(details.id, shiftLocation.id);
  //   }
  // }

  handleUploadEAPDoc = () => this.props.onFieldChange('generateOrUpload', 'upload');
  autoGenerateEAPDoc = () => this.props.onFieldChange('generateOrUpload', 'generate');

  pageIsValid = () => {
    if (isEmpty(this.props.form) || !this.props.authenticated) return false;

    const { generateOrUpload, uploadedPlanPreview } = this.props.form;
    return generateOrUpload === 'generate' || uploadedPlanPreview;
  };

  onSaveAndContinue = () => {
    if (!this.pageIsValid()) return;

    const { equipments } = this.props.shiftLocation.supplies;
    if (!this.props.form.id) {
      equipments.forEach((eq) => {
        const subEq = eq?.split(',').map((e) => e.trim());
        subEq.forEach((eq) => this.props.addEquipment(eq));
      });
    }

    this.props.history.push(`${this.props.baseUrl}/eap/review`);
  };

  render() {
    const { form } = this.props;

    const { uploadedPlan, generateOrUpload, uploadedPlanPreview } = form;
    return (
      <div className="emergencyActionPlan">
        <div id="attribution"></div>
        <main>
          <header>
            <div className="screen-title">Emergency Action Plan (EAP)</div>
          </header>
          <div className="emergencyActionPlanContainer nimbus-regular-font">
            <span className="info-label nimbus-regular-font">Be prepared with a plan for emergencies or severe incidents.</span>
            <span className="sub-info-label nimbus-regular-font">An EAP includes contact info for nearby police, fire & hospital—essential for fast, effective response and protecting everyone on-site.</span>
            <span className="message-label bold">
              Choose how you'd like to add an EAP for this job:
            </span>
            <div className="eap-button-section">
              <button
                className={classNames('eap-auto-generate-button gotham-bold-font', {
                  selected: generateOrUpload === 'generate',
                })}
                onClick={this.autoGenerateEAPDoc}
              >
                <span className="labelText">Auto-Generate / </span>
                <span className="sub-text nimbus-regular-font"> Go4 will create one based on job details</span>
              </button>
              <div className="eap-upload-section">
                <button
                  className={classNames('eap-upload-button gotham-bold-font', {
                    selected: generateOrUpload === 'upload',
                  })}
                  onClick={this.handleUploadEAPDoc}
                >
                  <span className="labelText">Upload /</span>
                  <span className="sub-text nimbus-regular-font"> Use an existing emergency action plan</span>
                </button>
                {generateOrUpload === 'upload' && (
                  <UploadDoc
                    onFieldChange={this.props.onFieldChange}
                    uploadedPlan={uploadedPlan}
                    uploadedPlanPreview={uploadedPlanPreview}
                  />
                )}
              </div>
            </div>
          </div>
          <ActionBar
            editMode={this.props.editMode}
            backTo={`${this.props.baseUrl}/details/credentials`}
            currentStep="eap/eap-type"
            onSaveAndContinue={this.onSaveAndContinue}
            nextDisabled={() => !this.pageIsValid()}
          />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { currentForm } = state.post.eap;
  const form = get(state, `post.eap.forms[${currentForm}]`, {});
  const { locationIdx } = state.post.navigation;
  const shiftLocation = state.post.locations[locationIdx];

  return {
    form,
    shiftLocation,
    ...state.post,
    authenticated: state.session.authenticated,
    user: state.session.currentUser,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onFieldChange: (name, value) => dispatch(fieldChange({ name, value })),
  addEquipment: (name) => dispatch(addEquipment({ name })),
  initEAPForm: (eventId, eventLocationId) => dispatch(initEAPForm({ eventId, eventLocationId })),
  saveLocalForm: () => dispatch(saveLocalForm()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmergencyActionPlan));
